import { Component, OnInit } from '@angular/core';

import { AppserviceService } from 'src/app/appservice.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-bookkit',
  templateUrl: './bookkit.component.html',
  styleUrls: ['./bookkit.component.sass']
})
export class BookkitComponent implements OnInit {
  viperbag:string;
  trackingmethod:string;
  partsIssueData = {
    'bootkit':[],
    'bootkitpart':[]
  };
  partsIssueDataObj:{} = {
    "viperbag": "", 
    "trackingMethod":""
  };
  receiptPartObj:{} = {
    'to_bin':''
  };

  bootkitObj = [];
  bootkitObjBool:boolean = false;
  error:boolean;
  bootkitModalBool:boolean = false;
  bootkitServBool = '';
  bootkitServComment = '';
  serviceClass = '';
  rslPartUpdate:boolean = false;

  engData:any;
  strData:any;

  constructor(private AppService:AppserviceService,private modalService:NgbModal, private spinner:NgxSpinnerService) { }

  fetchPartsforissue(){
    this.partsIssueDataObj['viperbag'] = this.viperbag;
    this.partsIssueDataObj['trackingMethod'] = this.trackingmethod;
    //console.log(this.receiptPartObj);
    this.spinner.show();
    this.AppService.getBootkitService(this.partsIssueDataObj).subscribe((dataObj) => {
      this.spinner.hide();
      this.partsIssueData['bootkit'] = dataObj['data'][0];
      this.bootkitModalBool = false;
      if(dataObj['success'] && dataObj['data'][0]['tra_code'] != ''){
        this.fetchBootkitPart(dataObj['data'][0]);
      }else{
        this.error = true;
        this.bootkitModalBool = false;
        this.partsIssueData['bootkitpart'] = [];
      }
    },
    (error) => {
      this.spinner.hide();
      console.log(error);
    });
  }

  fetchBootkitPart(dataObj){
    this.spinner.show();
    this.AppService.getBootkitPart(dataObj['tra_code']).subscribe((bootKitPartObj) => {
      this.spinner.hide();
      this.error = false;
      console.log(bootKitPartObj);
      //console.log(bootKitPartObj['data'],this.receiptPartObj['to_bin']);
      this.partsIssueData['bootkitpart'] =  bootKitPartObj['data'][0];
      this.bootkitObjBool = true;
      var that = this;

      this.AppService.rslPartAwait(this.partsIssueData['bootkitpart']['prv_value']).subscribe((rslPartAwaitRes) => {
        console.log(rslPartAwaitRes);
        (rslPartAwaitRes['data'][0]['evt_status'] === 'PART')? this.rslPartUpdate = true: this.rslPartUpdate = false;
      },
      (error) => {
        console.log(error);
      });

      this.AppService.getRslData().forEach(function(item){
        if(item.name === bootKitPartObj['data'][0]['req_tocode']){
          that.receiptPartObj['to_bin'] = 'GOODSIN';
        }
      });
      this.AppService.getEngData().forEach(function(item){
        if(item.name === bootKitPartObj['data'][0]['req_tocode']){
          that.receiptPartObj['to_bin'] = 'FEBIN';
        }
      });
      //console.log(bootKitPartObj);
    }, (error) => {
      this.spinner.hide();
    });
  }

  bookitSubmit(){
    /* var reqNo = this.partsIssueData['bootkitpart']['tst_req']; */
    this.receiptPartObj['req_code'] = parseInt(this.partsIssueData['bootkitpart']['tst_req']);
    this.receiptPartObj['from_store'] = this.partsIssueData['bootkitpart']['req_fromcode'];
    this.receiptPartObj['to_store'] = this.partsIssueData['bootkitpart']['req_tocode'];
    this.receiptPartObj['qty'] = this.partsIssueData['bootkitpart']['tst_qty'];
    this.receiptPartObj['part_code'] = this.partsIssueData['bootkitpart']['par_code'];
    this.receiptPartObj['engineer'] = localStorage.getItem('username');
    //console.log(this.receiptPartObj);
    this.spinner.show();
    this.AppService.receiptPart(this.receiptPartObj).subscribe(
      (receiptObj) => {
        this.spinner.hide();
        //console.log(receiptObj);
        this.bootkitServBool = 'Success';
        this.bootkitServComment = receiptObj['message'];
        this.serviceClass = 'bg-success text-white ';
        if(this.rslPartUpdate){
          this.AppService.rslPartUpdate(this.partsIssueData['bootkitpart']['prv_value']).subscribe(
            (rslPartUpdate) => {
              console.log('RSL updated');
            },
            (error) => {
              console.log('RSL updated error');
            }
          );
        }
      },
      (error) => {
        this.spinner.hide();
        if(!error['success']){
          //console.log(error['error']['message']['message'].split(':')[1]);
          this.bootkitServBool = 'Error';
          this.bootkitServComment = error['error']['message']['message'].split(':')[1];
          this.serviceClass = 'bg-danger text-white ';
        }
      }
    );
    this.bootkitModalBool = true;
  }

  onItemChange(event){
    //console.log(event.target.value);
    this.trackingmethod = event.target.value;
  }

  ngOnInit() {
  }

}
